(function () {
class $b901289d9489a783$var$ThemeManager {
    #htmlDOC = document.documentElement;
    #preferedTheme;
    #applyTheme() {
        this.#htmlDOC.setAttribute("data-theme", this.#preferedTheme);
        localStorage.setItem("data-theme", this.#preferedTheme);
    }
    #getPreferedTheme() {
        this.#preferedTheme = localStorage.getItem("data-theme");
        if (!this.#preferedTheme) this.#preferedTheme = matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    switchTheme() {
        this.#preferedTheme = this.#preferedTheme === "dark" ? "light" : "dark";
        this.#applyTheme();
    }
    init() {
        this.#getPreferedTheme();
        this.#applyTheme();
    }
    constructor(){}
}
var $b901289d9489a783$export$2e2bcd8739ae039 = new $b901289d9489a783$var$ThemeManager();


/**
 * Checks if the browser prefers reduced motion
 *
 * @returns {boolean} - true if the browser prefers reduce motion, else false
 */ const $f9786eaa90432c56$var$prefersReduced = function() {
    return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
};
// Scroll lock util
const $f9786eaa90432c56$var$ScrollLock = (()=>{
    let y = 0;
    return {
        lock () {
            y = window.scrollY || document.documentElement.scrollTop;
            document.body.style.position = "fixed";
            document.body.style.top = `-${y}px`;
            document.body.style.left = "0";
            document.body.style.right = "0";
            document.body.style.width = "100%";
        },
        unlock () {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.right = "";
            document.body.style.width = "";
            const html = document.documentElement;
            const prevScrollBehavior = html.style.scrollBehavior;
            html.style.scrollBehavior = "auto";
            window.scrollTo({
                top: y,
                left: 0
            });
            html.style.scrollBehavior = prevScrollBehavior || "";
        }
    };
})();
class $f9786eaa90432c56$var$Navbar {
    // Mobile Navigation
    #mobileNavPanel = document.querySelector(".mobile__nav__panel");
    #mobileNavBtn = document.querySelector(".mobile__nav__btn");
    #mobileNavIsOpen = false;
    //THEMES
    #themeToggleBtns = document.querySelectorAll(".settings-theme__btn");
    #header = document.querySelector(".header");
    #footerNav = document.querySelector(".footer__navbar");
    // SCROLL
    #scrollingTo;
    #currSection;
    #allSections = document.querySelectorAll("section");
    #scrollSpyLinks = document.querySelectorAll(".scrollspy");
    #initMobileNav() {
        if (!this.#mobileNavPanel || !this.#mobileNavBtn) return;
        this.#mobileNavBtn.addEventListener("click", this.#handleMobileNavState.bind(this));
        this.#mobileNavPanel.addEventListener("transitionend", this.#disableAfterTransition.bind(this));
    }
    #handleMobileNavState(event) {
        this.#mobileNavIsOpen = !this.#mobileNavIsOpen;
        // Mirror state on the root for layout/body scroll locking via CSS
        const parentDoc = document.documentElement.classList;
        const body = document.body.classList;
        parentDoc.toggle("mobile-open");
        body.toggle("mobile-open");
        this.#mobileNavBtn.setAttribute("aria-expanded", `${this.#mobileNavIsOpen}`);
        this.#mobileNavPanel.classList.toggle("mobile-open");
        // Enabling mobileNavPanel functions
        if (this.#mobileNavIsOpen) {
            this.#mobileNavPanel.classList.remove("disabled");
            $f9786eaa90432c56$var$ScrollLock.lock();
        } else $f9786eaa90432c56$var$ScrollLock.unlock();
        // If reduce motion is preferred disable imediately, otherwise the panel will be disabled later on, after the transition ends
        if ($f9786eaa90432c56$var$prefersReduced() && !this.#mobileNavIsOpen) this.#mobileNavPanel.classList.add("disabled");
        this.#changeMobileNavBtnIcon();
    }
    #disableAfterTransition(event) {
        if (event.propertyName !== "transform") return;
        if (!this.#mobileNavIsOpen) this.#mobileNavPanel.classList.add("disabled");
    }
    #changeMobileNavBtnIcon() {
        const icon = this.#mobileNavBtn.querySelector("ion-icon");
        if (!icon) return;
        icon.setAttribute("name", this.#mobileNavIsOpen ? "close-outline" : "menu-outline");
        icon.classList.toggle("is-open");
    }
    #initThemeToggle() {
        this.#themeToggleBtns.forEach((btn)=>btn.addEventListener("click", function() {
                (0, $b901289d9489a783$export$2e2bcd8739ae039).switchTheme();
            }));
    }
    // Closing the mobileNav when clicking an anchor
    #initCloseMobileNav() {
        this.#mobileNavPanel.addEventListener("click", this.#CloseMobileNavOnAnchor.bind(this));
    }
    #CloseMobileNavOnAnchor(event) {
        const anchor = event.target.closest(".navbar__scroll");
        if (!anchor) return;
        event.preventDefault();
        this.#mobileNavBtn.click();
    }
    #initScrollToSection() {
        [
            this.#header,
            this.#mobileNavPanel,
            this.#footerNav
        ].forEach((navbar)=>navbar.addEventListener("click", this.#scrollToSection.bind(this)));
    }
    #scrollToSection(event) {
        const anchor = event.target.closest(".navbar__scroll");
        if (!anchor) return;
        event.preventDefault();
        const sectionId = anchor.getAttribute("href");
        const sectionToScroll = document.querySelector(sectionId === "#" ? "#home" : sectionId);
        if (sectionToScroll) {
            if (this.#currSection !== sectionId.slice(1)) {
                this.#scrollingTo = sectionId.slice(1);
                this.#setActiveAnchor(this.#scrollingTo);
            }
        }
        sectionToScroll.scrollIntoView({
            behavior: "smooth"
        });
    }
    #initScrollSpy() {
        const headerHeight = document.querySelector(".header").offsetHeight;
        const virtualVH = window.innerHeight - headerHeight;
        const sectionObserver = new IntersectionObserver(this.#setActiveSection.bind(this), {
            threshold: 0,
            rootMargin: `-${virtualVH * 0.5}px 0px -${virtualVH * 0.5}px 0px`
        });
        this.#allSections.forEach((sect)=>sectionObserver.observe(sect));
    }
    #setActiveAnchor(sectionId) {
        this.#scrollSpyLinks.forEach((link)=>{
            link.classList.remove("active");
            const linkHref = link.getAttribute("href").slice(1);
            if (linkHref === sectionId) link.classList.add("active");
        });
    }
    #setActiveSection(entries) {
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            this.#currSection = entry.target.getAttribute("id");
            if (this.#scrollingTo) {
                if (this.#scrollingTo === this.#currSection) this.#scrollingTo = null;
                return;
            }
            this.#setActiveAnchor(this.#currSection);
        });
    }
    init() {
        this.#scrollingTo = null;
        this.#initMobileNav();
        this.#initThemeToggle();
        this.#initCloseMobileNav();
        this.#initScrollToSection();
        this.#initScrollSpy();
    }
}
var $f9786eaa90432c56$export$2e2bcd8739ae039 = new $f9786eaa90432c56$var$Navbar();



class $edfb4c949156f8cc$var$Projects {
    #projectStacksContainer = document.querySelector(".projects-stacks");
    #stackBtns = Array.from(document.querySelectorAll(".stack")).filter((btn)=>btn.dataset.filter !== "all");
    #allStacksBtn = document.querySelector(".stack-all");
    #projectCards = document.querySelectorAll(".card");
    #noProjectsText = document.querySelector(".no-projects");
    #moreStacksBtn = document.querySelector(".more-stacks__btn");
    #activeStacks = new Set();
    constructor(){}
    #initStateManager() {
        this.#projectStacksContainer.addEventListener("click", this.#manageStates.bind(this));
        [
            this.#allStacksBtn,
            ...this.#stackBtns
        ].forEach((btn)=>btn.addEventListener("mouseleave", this.#disableJustClicked));
    }
    #isActiveStack(stackBtn) {
        return stackBtn.classList.contains("active-stack");
    }
    #manageStates(event) {
        const target = event.target.closest(".stack");
        if (!target) return;
        event.preventDefault();
        if (target.dataset.filter === "all") {
            if (this.#isActiveStack(target)) return;
            this.#stackBtns.forEach((st)=>st.classList.remove("active-stack"));
            target.classList.add("active-stack");
            target.classList.add("just-clicked-active");
            this.#activeStacks.clear();
            this.#activeStacks.add(target.dataset.filter);
        } else if (this.#isActiveStack(target)) {
            target.classList.remove("active-stack");
            target.classList.add("just-clicked-unactive");
            this.#activeStacks.delete(target.dataset.filter);
        } else {
            target.classList.add("active-stack");
            this.#allStacksBtn.classList.remove("active-stack");
            target.classList.add("just-clicked-active");
            this.#activeStacks.add(target.dataset.filter);
            this.#activeStacks.delete(this.#allStacksBtn.dataset.filter);
        }
        // If no options, choose all
        if (this.#activeStacks.size === 0) {
            this.#activeStacks.add(this.#allStacksBtn.dataset.filter);
            this.#allStacksBtn.classList.add("active-stack");
        }
        this.#filterProjects();
    }
    #disableJustClicked(event) {
        event.target.classList.remove("just-clicked-active");
        event.target.classList.remove("just-clicked-unactive");
    }
    #enableProject(proj) {
        proj.classList.remove("card--disabled");
    }
    #disableProject(proj) {
        proj.classList.add("card--disabled");
    }
    #filterProjects() {
        let noProjects = true;
        this.#projectCards.forEach((proj)=>{
            if (this.#activeStacks.has("all")) {
                noProjects = false;
                this.#enableProject(proj);
                return;
            }
            const projStacks = new Set(proj.dataset.stacks.split(";"));
            const activeArr = [
                ...this.#activeStacks
            ];
            if (activeArr.every((stack)=>projStacks.has(stack))) {
                noProjects = false;
                this.#enableProject(proj);
            } else this.#disableProject(proj);
        });
        if (noProjects) this.#noProjectsText.classList.remove("disabled");
        else this.#noProjectsText.classList.add("disabled");
    }
    #initMoreStacksBtn() {
        this.#moreStacksBtn.addEventListener("click", this.#showMoreOrLessStack.bind(this));
    }
    #showMoreOrLessStack() {
        this.#stackBtns.slice(3).forEach((btn)=>btn.classList.toggle("stack--hidden"));
        this.#moreStacksBtn.children[0].setAttribute("name", this.#moreStacksBtn.children[0].name.startsWith("add") ? "remove" : "add-outline");
    }
    init() {
        if (this.#allStacksBtn) this.#activeStacks.add(this.#allStacksBtn.dataset.filter);
        this.#initStateManager();
        this.#filterProjects();
        this.#initMoreStacksBtn();
    }
}
var $edfb4c949156f8cc$export$2e2bcd8739ae039 = new $edfb4c949156f8cc$var$Projects();


class $f5bd28884a4296fa$var$Hero {
    #scrollDownArrow = document.querySelector(".scroll-down");
    #hero = document.querySelector(".hero");
    constructor(){}
    #initScrollArrow() {
        if (!this.#scrollDownArrow || !this.#hero) return;
        const observer = new IntersectionObserver((entries)=>entries.forEach((entry)=>{
                if (!entry.isIntersecting) {
                    this.#scrollDownArrow.classList.add("disabled");
                    observer.disconnect();
                }
            }));
        observer.observe(this.#hero);
    }
    init() {
        this.#initScrollArrow();
    }
}
var $f5bd28884a4296fa$export$2e2bcd8739ae039 = new $f5bd28884a4296fa$var$Hero();


function $4252faad1829c952$var$getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        const cookies = document.cookie.split(";");
        for (let cookie of cookies){
            cookie = cookie.trim();
            if (cookie.startsWith(name + "=")) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
class $4252faad1829c952$var$Form {
    #submitBtn = document.querySelector(".submit__btn");
    #form = document.querySelector(".contact__form");
    #translations = document.querySelector(".btn-translations").dataset;
    #reCapthcaInput = document.querySelector(".reCaptcha");
    #inputs = [];
    //STATES
    #STATES = {
        READY_TO_SEND: 0,
        SENDING: 1,
        SENT: 2,
        FAILED: 3
    };
    #BTN_STATES = {
        0: {
            html: `<span>${this.#translations.send}</span>`,
            disabled: false,
            timeout: 0,
            classToAdd: "",
            classToRemove: "deactivated"
        },
        1: {
            html: `<div class="sk-chase">
            <div class="sk-chase-dot"></div>
            <div class="sk-chase-dot"></div>
            <div class="sk-chase-dot"></div>
            <div class="sk-chase-dot"></div>
            <div class="sk-chase-dot"></div>
            <div class="sk-chase-dot"></div>
          </div>`,
            disabled: true,
            timeout: 0,
            classToAdd: "deactivated",
            classToRemove: ""
        },
        2: {
            html: `<ion-icon name="checkmark-outline"></ion-icon><span>${this.#translations.sent}</span>`,
            disabled: true,
            timeout: 5000,
            classToAdd: "deactivated",
            classToRemove: ""
        },
        3: {
            html: `<ion-icon name="close-outline"></ion-icon><span>${this.#translations.failed}</span>`,
            disabled: true,
            timeout: 2000,
            classToAdd: "deactivated",
            classToRemove: ""
        }
    };
    #STATE;
    #initSubmitBtn() {
        this.#form.addEventListener("submit", this.#sumbitForm.bind(this));
    }
    async #sumbitForm(event) {
        event.preventDefault();
        const csrfToken = $4252faad1829c952$var$getCookie("csrftoken");
        const url = this.#form.dataset.url;
        this.#STATE = this.#STATES.SENDING;
        this.#applySumbitState();
        try {
            await this.#refreshReCaptcha();
            const formData = new FormData(this.#form);
            if (!this.#validateAllInput()) {
                this.#STATE = this.#STATES.FAILED;
                this.#applySumbitState();
                return;
            }
            const response = await fetch(url, {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRFToken": csrfToken
                }
            });
            if (response.ok) this.#STATE = this.#STATES.SENT;
            else this.#STATE = this.#STATES.FAILED;
        } catch (err) {
            this.#STATE = this.#STATES.FAILED;
        }
        this.#applySumbitState();
    }
    async #refreshReCaptcha() {
        return new Promise((resolve, reject)=>grecaptcha.ready(()=>{
                grecaptcha.execute("6LcYw-wrAAAAAMrZFIx6iK81Qr0y8jw5KUvU95vi", {
                    action: "contact"
                }).then((token)=>{
                    this.#reCapthcaInput.setAttribute("value", token);
                    resolve();
                }).catch((error)=>{
                    reject(error);
                });
            }));
    }
    #applySumbitState() {
        const stateData = this.#BTN_STATES[this.#STATE];
        this.#submitBtn.innerHTML = stateData.html;
        this.#submitBtn.disabled = stateData.disabled;
        if (stateData.timeout !== 0) setTimeout(this.#reactivateSubmit.bind(this), stateData.timeout);
        if (stateData.classToAdd) this.#submitBtn.classList.add(stateData.classToAdd);
        if (stateData.classToRemove) this.#submitBtn.classList.remove(stateData.classToRemove);
    }
    #reactivateSubmit() {
        this.#STATE = this.#STATES.READY_TO_SEND;
        this.#applySumbitState();
    }
    #initInputs() {
        const htmlInputs = document.querySelectorAll(".form__input");
        const htmlErorrs = document.querySelectorAll(".error-message");
        for(let i = 0; i < htmlInputs.length; i++){
            const currInput = htmlInputs[i];
            const currError = htmlErorrs[i];
            let type;
            if (currInput instanceof HTMLTextAreaElement) type = "text";
            else type = currInput.type;
            this.#inputs.push(new $4252faad1829c952$var$Input(currInput, currError, type, !currInput.required));
        }
    }
    #validateAllInput() {
        return this.#inputs.every((input)=>input.validateInput());
    }
    init() {
        this.#form.setAttribute("novalidate", "true");
        this.#STATE = this.#STATES.READY_TO_SEND;
        this.#initSubmitBtn();
        this.#initInputs();
    }
}
var $4252faad1829c952$export$2e2bcd8739ae039 = new $4252faad1829c952$var$Form();
class $4252faad1829c952$var$Input {
    #htmlElement;
    #errorElement;
    #type;
    #blank;
    #TYPES = {
        text: 0,
        email: 1
    };
    #VALIDATORS = {
        0: this.#textValidation.bind(this),
        1: this.#emailValidation.bind(this)
    };
    constructor(htmlElement, errorElement, type, blank = false){
        this.#htmlElement = htmlElement;
        this.#errorElement = errorElement;
        this.#type = this.#TYPES[type];
        this.#blank = blank;
        this.#htmlElement.addEventListener("blur", this.#validateOnBlur.bind(this));
    }
    #validateOnBlur(event) {
        event.preventDefault();
        if (this.validateInput()) this.#hideError();
        else this.#showError();
    }
    validateInput() {
        if (this.#blank) return true;
        return this.#VALIDATORS[this.#type]();
    }
    #textValidation() {
        return this.#htmlElement.value;
    }
    #emailValidation() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(this.#htmlElement.value);
    }
    #showError() {
        this.#htmlElement.classList.add("error");
        this.#errorElement.classList.add("active");
    }
    #hideError() {
        this.#htmlElement.classList.remove("error");
        this.#errorElement.classList.remove("active");
    }
}


var $d10b7f404b74840a$import_meta = Object.assign(Object.create(null), {
    url: "file:///js/index.js"
});
const $d10b7f404b74840a$var$resetScroll = function() {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    history.replaceState(null, "", window.location.pathname + window.location.search);
    window.scrollTo(0, 0);
};
const $d10b7f404b74840a$var$init = function() {
    $d10b7f404b74840a$var$resetScroll();
    (0, $f9786eaa90432c56$export$2e2bcd8739ae039).init();
    (0, $b901289d9489a783$export$2e2bcd8739ae039).init();
    (0, $edfb4c949156f8cc$export$2e2bcd8739ae039).init();
    (0, $f5bd28884a4296fa$export$2e2bcd8739ae039).init();
    (0, $4252faad1829c952$export$2e2bcd8739ae039).init();
};
$d10b7f404b74840a$var$init();
if ($d10b7f404b74840a$import_meta.hot) $d10b7f404b74840a$import_meta.hot.dispose(()=>{
    window.location.reload();
});

})();
//# sourceMappingURL=index.js.map
